import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {MemberDetailsReportModel} from "./member-details-report.model";

@Component({
    selector: "wbo-member-details-report",
    templateUrl: "./member-details-report.component.html",
    providers: [provideReportModel(MemberDetailsReportModel)]
})
export class MemberDetailsReportComponent extends AbstractReportPage {
    constructor(public model: MemberDetailsReportModel) {
        super();
    }
}
